var _rect, _rect2, _rect3, _rect4, _circle, _rect5, _rect6, _rect7, _circle2, _rect8, _rect9, _rect10, _circle3, _rect11, _rect12, _rect13, _circle4, _rect14, _rect15, _rect16, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 292,
    viewBox: "0 0 252 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 250,
    height: 290,
    rx: 10,
    fill: "currentColor",
    stroke: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 200,
    height: 40,
    rx: 4,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36,
    width: 80,
    height: 6,
    rx: 3,
    fill: "#F3F4F6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 50,
    width: 150,
    height: 6,
    rx: 3,
    fill: "#F3F4F6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 46,
    r: 10,
    fill: "#F3F4F6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 76,
    width: 200,
    height: 40,
    rx: 4,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 86,
    width: 80,
    height: 6,
    rx: 3,
    fill: "#F3F4F6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 100,
    width: 150,
    height: 6,
    rx: 3,
    fill: "#F3F4F6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 96,
    r: 10,
    fill: "#F3F4F6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 126,
    width: 200,
    height: 40,
    rx: 4,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 136,
    width: 80,
    height: 6,
    rx: 3,
    fill: "#F3F4F6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 150,
    width: 150,
    height: 6,
    rx: 3,
    fill: "#F3F4F6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 146,
    r: 10,
    fill: "#F3F4F6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 176,
    width: 200,
    height: 40,
    rx: 4,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 186,
    width: 80,
    height: 6,
    rx: 3,
    fill: "#F3F4F6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 200,
    width: 150,
    height: 6,
    rx: 3,
    fill: "#F3F4F6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 196,
    r: 10,
    fill: "#F3F4F6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 226,
    width: 200,
    height: 40,
    rx: 4,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 236,
    width: 80,
    height: 6,
    rx: 3,
    fill: "#F3F4F6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 250,
    width: 150,
    height: 6,
    rx: 3,
    fill: "#F3F4F6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 246,
    r: 10,
    fill: "#F3F4F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFound);
export default __webpack_public_path__ + "static/media/no-data-found.903bed7868f931820e036ef0d336d773.svg";
export { ForwardRef as ReactComponent };